<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (cart) {
      <ion-title>
        @if (!cart.special_instructions && !cart.customer_note && !cart.internal_note) {
          <span>Add additional info</span>
        }
        @if (cart.special_instructions || cart.customer_note || cart.internal_note) {
          <span>Update additional info</span>
        }
      </ion-title>
    }
    <ion-buttons slot="end">
      <ion-button (click)="update()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-grid class="form">
    <ion-row>
      <ion-col>
        <ion-grid class="fieldset">
          <ion-row>
            <ion-col>
              <ion-textarea type="text" inputmode="text" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="special_instructions">
                <div slot="label">Special instructions<ion-text class="optional">optional</ion-text></div>
              </ion-textarea>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-textarea type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="customer_note">
                <div slot="label">Note for customer<ion-text class="optional">optional</ion-text></div>
              </ion-textarea>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-textarea type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="internal_note">
                <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
              </ion-textarea>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>